import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['nestedForm', 'row'];

  connect() {
    if (!this.hasRowTarget) {
      Promise.resolve().then(() => this.add(new Event('click')));
    }
  }

  add(e) {
    this.application
      .getControllerForElementAndIdentifier(this.nestedFormTarget, 'nested-form')
      .add(e);
  }
}
